import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Redux/actions.js"
import { ClaimStatusEnum } from "../../enum.js";
import find from 'lodash/find';
import { getPartnerGuid, hasAuthourity } from "../../../../../lib/access.es6.js";
import ClaimsHeader from "../ClaimsHeader/ClaimsHeader.js";
import ClaimsWrapper from "../ClaimsWrapper/ClaimsWrapper.js";


class CancerClaims extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }  

  componentWillMount() {
    const payload = {
      "partner": getPartnerGuid(),
      "statuses": ClaimStatusEnum.docs_pending
    }
    this.props.dispatch(actions.getClaimsDcpRequest(payload))
  }

  getClaims(payload) {
    this.props.dispatch(actions.getClaimsDcpRequest(payload
    ))
  }

  handleBulkApproval(payload) {
    this.props.dispatch(actions.bulkApproveRequest(payload))
  }

  filterHospitalClaim(claims) {
    return claims.filter(claim => claim.preauthorization_number !== null)
  }

  isDeathClaim(claim) {
    const hasDeathBenefit = !!find(claim.benefits, { type: "LAST EXPENSE" })
    return hasDeathBenefit
  }

  isHospitalClaim(claim) {
    const hasHospitalBenefit = !!find(claim.benefits, { type: "HOSPITAL ADMISSION" })
     return hasHospitalBenefit 
   }

   

   isCancerClaim(claim) {
    const hasCancerBenefit = !!find(claim.benefits, { type: "CANCER CARE" })
     return hasCancerBenefit 
   }

  filterDeathClaim(claims) {
    return claims.filter(claim => this.isDeathClaim(claim))
  }
  filterHospitalClaims(claims){

      return claims.filter(claim => this.isHospitalClaim(claim));
  }
  filterCancerClaims(claims){

    return claims.filter(claim => this.isCancerClaim(claim));
}

  render() {
    const claimEx = this.props.bulkApprovalData.claims_dcp || []
    const claims = this.filterCancerClaims(claimEx)

    if (!hasAuthourity('VIEW_CLAIM')) {
      return <p>You are unauthorized to view claims.</p>
    }

    return (
      <>
        <ClaimsHeader
          title="Cancer Care Claims Dashboard"
        />

        <ClaimsWrapper
          claimsData={claims}
          type="reimbursement"
          hasAlerts={true}
          hasBulkApprove={true}
          getClaims={this.getClaims.bind(this)}
          loading={this.props.bulkApprovalData.get_claims_dcp_loader}
          handleBulkApproval={this.handleBulkApproval.bind(this)}

          showBulkApproveProgressAlert={this.props.bulkApprovalData.bulkApprovalClaimLoader}
          showBulkApproveSuccessAlert={this.props.bulkApprovalData.bulkApprovalClaimSuccess}
          showBulkApproveErrorAlert={!!this.props.bulkApprovalData.bulkApprovalClaimError}
          bulkApproveError={this.props.bulkApprovalData.bulkApprovalClaimError}

          resetBulkApproveSuccessAlert={() => { this.props.dispatch(actions.resetbulkApprovalSuccess()) }}
          resetBulkApproveErrorAlert={() => { this.props.dispatch(actions.resetbulkApprovalFailure()) }}
        />
      </>
    )

  }

}
export default connect((state) => ({
  customerData: state.currentCustomer,
  claimDashboardData: state.claimDashboardData,
  bulkApprovalData: state.bulkApprovalData,
  globalData: state.global,
}))(CancerClaims);